import { render, staticRenderFns } from "./InspectionEventsTable.vue?vue&type=template&id=2e492693&scoped=true&"
import script from "./InspectionEventsTable.vue?vue&type=script&lang=js&"
export * from "./InspectionEventsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e492693",
  null
  
)

export default component.exports